import React from 'react';
import {
  Card,
  CardContent,
  CardActionArea,
  CardActionAreaProps,
  Typography,
  CardProps,
  Stack,
  Chip,
  ChipProps,
  Checkbox,
} from '@mui/material';

import { useAppSelector } from '../../../../hooks';
import { getThemeMode } from '../../../../store/ConfigSlice';
import { TP_COLORS } from '../../../../constants';

export interface IQuestionCard {
  questionId: string;
  title: string;
  description: string;
  chips?: Array<ChipProps>;
  isSelected?: boolean;
  isChecked?: boolean;
  isIncluded?: boolean;
  onCardClick?: CardActionAreaProps['onClick'];
  onCheckClick: (questionId: string, isChecked: boolean) => void;
}

const QuestionCard: React.FC<IQuestionCard> = ({
  questionId,
  title,
  description,
  chips,
  isSelected = false,
  isChecked = false,
  isIncluded = false,
  onCardClick,
  onCheckClick,
}) => {
  const themeMode = useAppSelector(getThemeMode);

  const defaultStyles: CardProps['sx'] = {
    mb: 0,
  };
  if (isSelected) {
    defaultStyles.backgroundColor =
      themeMode === 'light' ? '#f1f8ff' : TP_COLORS.paperGray.dark;
  }

  return (
    <Card elevation={0} sx={defaultStyles}>
      <CardActionArea onClick={onCardClick}>
        <CardContent>
          <Typography fontWeight={600} variant="subtitle2">
            <Checkbox
              disableRipple
              disabled={isIncluded}
              style={{ padding: '0 5px 0 0' }}
              checked={isChecked}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                onCheckClick(questionId, event.currentTarget.checked)
              }
            />
            {title}
          </Typography>
          <Typography variant="subtitle2" className="ellipsis-text two-lines">
            {description}
          </Typography>
          {chips && chips.length > 0 && (
            <Stack direction="row" alignItems="center" flexWrap="wrap">
              {chips.map((chipProps, index) => {
                const defaultChipStyles: ChipProps['sx'] = {
                  borderRadius: '4px',
                  mt: '5px',
                  mr: chips.length - 1 === index ? '0' : '5px',
                  textTransform: 'capitalize',
                };
                return (
                  <Chip
                    key={index}
                    {...chipProps}
                    sx={
                      chipProps && chipProps.sx
                        ? { ...defaultChipStyles, ...chipProps.sx }
                        : defaultChipStyles
                    }
                    size={
                      chipProps && chipProps.size ? chipProps.size : 'small'
                    }
                    variant={
                      chipProps && chipProps.variant
                        ? chipProps.variant
                        : 'filled'
                    }
                  />
                );
              })}
            </Stack>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default QuestionCard;
